/*
 * @Author: LiuMouLiang
 * @Date:   2021-11-25 09:41:01
 */
/* eslint-disable */
import { VERSION, BASE_API, KJ_PAGE_URL, ROUTE_URL_PC, IS_RELEASE } from '_libs/host'
import {
    _for,
    _cloneObj,
    _error,
    _paramsToString,
    _getAllParams,
    _formatDate,
    _encode,
    _float,
    _toNumber,
    numberComma,
    typeOf,
    setURLParams,
    getObjVal,
} from 'tools';

export const _toMoney = function(number) {
    return typeOf(number) === 'number' ? numberComma(_float(number)) : null;
};

//转金额并区分小数
export const toMoneySmall = function(data, isSmall, inkeys) {
    _for(data, (el, key) => {
        if (inkeys && !inkeys.includes(key)) return false;
        let num = _toMoney(el);
        if (num) {
            if (isSmall) {
                let ss = num.split('.');
                num = ss[1] ? `${ss[0]}<span class="small">.${ss[1]}</span>` : ss[0];
            };
            data[key] = num;
        }
    })
    return data;
};

//old-页面没有登录不能使用route跳转
// 参考以前的跳转
export const jump = function(url, type) {
    if (url && ~url.indexOf('://')) {
        if(type==1){
            window.open(url, '_blank')
        }else{
            window.location.href = url;
        };
    }else{
        window.location.href = `${KJ_PAGE_URL}${ROUTE_URL_PC}#${url}`;
    };
};

//获取标准json格式
export const getStandardJsonFormat = function(json){
    console.log(json);
    let data = []
    _for(json,(val,key)=>{
        data.push({
            label: val,
            value: key
        });
    });
    return data;
};

//数字拆分10进制状态
export const getSplitNumber10 = function(number){
    let data = (number+'').split('');
    let max = data.length;
    let res = [];
    for(let i = 0, len = max; i < len; i++){
        max = max-1;
        res.push(+`${data[i]}e${max}`);
    };
    return res;
};

//# url地址改变
export const setLinkUrl = function(changes, isR){
    const url = setURLParams(null,changes,isR);
    return window.history && history.replaceState(null,null,url);
}

//# select控件-快速查询关联性数据
//# use
// getSelectRelevanceData.call(this,code,tag,formManege,formInfo);
// getSelectRelevanceData.call(this,code,tag,formManege);
export const getSelectRelevanceData = function(value, formManegeTag, formManege, formInfo){
    const manege = getObjVal(formManege,`${formManegeTag}`) || {};
    const list_name = getObjVal(manege,`list-name`);
    const list_key = getObjVal(manege,`list-key`);
    const list = getObjVal(this,`${manege['_list']}`) || []; //对应的list
    const obj = list.find(_=>_[list_key] == value);
    if(obj){
        const res_name = manege._listName || list_name;
        const resData = formInfo || {};
        resData[res_name] = obj[list_name];
        return resData;
    }
};

// 将数字转换为大写字母，其中 A 的 Unicode 值是 65
export function convertNumberToLetter(num) {
    return String.fromCharCode(65 + num);
};

/**
 * @method  toChinesNum
 * @param   {Number}    num (整型)
 * @return  {String}
 *
 * @desc    description
 * @example
 *
 * toChinesNum(1562045) //一百五十六万二千零四十五
 */
export const toChinesNum = function(num) {
    let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']; //changeNum[0] = "零"
    let unit = ["", "十", "百", "千", "万"];
    num = parseInt(num);
    let getWan = (temp) => {
        let strArr = temp.toString().split("").reverse();
        let newNum = "";
        for (var i = 0; i < strArr.length; i++) {
            newNum = (i == 0 && strArr[i] == 0 ? "" : (i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? "" : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i]))) + newNum;
        }
        return newNum;
    }
    let overWan = Math.floor(num / 10000);
    let noWan = num % 10000;
    if (noWan.toString().length < 4) noWan = "0" + noWan;
    return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
};

export const go_history = function(num = -1){
    return window.history.go(num);
};

/* #埋点 */
const WeiyiStatSDK = window.WeiyiStatSDK || {};
let isStateWeiyiStatSDK = false;
export function analyUpdateConfig(pageId, params) {
    const resObj = params || {};
    resObj['ignorePageIdChange'] = true;
    if(pageId) {
        resObj['pageId'] = pageId;
    }
    // trace('埋点-updateConfig', resObj);
    if (WeiyiStatSDK && WeiyiStatSDK.submit) {
        return WeiyiStatSDK.updateConfig(resObj);
    };
};
export function analyInit(pageId, projectInfo, options) {
    if (WeiyiStatSDK && WeiyiStatSDK.init) {
        const default_projectInfo = {
            productType: 'tx',
            // url: window.location.href,
        };
        let resObj = {
            isProduct: IS_RELEASE,
            heartBeatRate: 5000,
            name: 'insurance-group-pc',
            version: '1.0.0',
        };
        if (projectInfo) {
            resObj['projectInfo'] = Object.assign({},default_projectInfo,projectInfo);
        }else{
            resObj['projectInfo'] = default_projectInfo;
        }
        if (pageId) {
            resObj['pageId'] = pageId;
        };
        if(options){
            Object.assign(resObj, options);
        }
        // trace('analyInit',resObj);
        /* 没有任何作用，更新和初始化一样，依然会额外发送一条老数据后再更新 */
        if(isStateWeiyiStatSDK){
            // trace('更新埋点页面');
            return analyUpdateConfig(null, resObj)
        }else{
            isStateWeiyiStatSDK = true;
            return WeiyiStatSDK.init(resObj);
        };
    }
}

export function analySubmit(id, params) {
    if (typeof id !== 'string') return false;
    const obj = params || {}
    if (WeiyiStatSDK && WeiyiStatSDK.submit) {
        return WeiyiStatSDK.submit(id, obj)
    };
};

//重置滚动位置
export function resetScrollTop(val = 0) {
    const mainEle = document.getElementById('main');
    if(mainEle){
        mainEle.scrollTop = val;
    };
};

// 表格符号并不是Unicode标准的一部分
export function generateTableNumber(n) {
    const numbers = ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨', '⑩'];
    return numbers[n];
};



// WEBPACK FOOTER //
// ./src/libs/util/util-pc.js